import HomeIcon from "@mui/icons-material/Home";
import SportsScoreIcon from "@mui/icons-material/SportsScore";
import { Divider, ListItem, ListItemText } from "@mui/material";
import { HHNTheme } from "hhn-commons";
import React from "react";
import { RouteChip } from "../Calendar.style";
import { ROUTE_ENDPOINT } from "./LocationAddressMarker";

function LocationAddressInfo(props: {
  location: google.maps.places.PlaceResult;
  endpoint: ROUTE_ENDPOINT;
}) {
  const isStart = props.endpoint === "start";
  return (
    <>
      <ListItem
        sx={{
          py: 2,
          flexDirection: "column",
          alignItems: "flex-start",
          cursor: "pointer",
        }}
      >
        <RouteChip
          label={isStart ? "Start" : "End"}
          markerColor={isStart ? HHNTheme.route.start : HHNTheme.route.end}
          size="small"
          icon={isStart ? <HomeIcon /> : <SportsScoreIcon />}
        />
        <ListItemText primary={props.location.formatted_address} />
      </ListItem>
      <Divider />
    </>
  );
}

export default LocationAddressInfo;
